/**
 * StreamingProvider contract — adaptive / progressive media attachment.
 * The playback engine never imports hls.js or other SDKs directly.
 *
 * Methods:
 *   initialize()
 *   supports(source) -> boolean
 *   attach(videoElement)
 *   detach()
 *   load(source, options) -> Promise
 *   destroy()
 *   getName()
 *   getLevels() / setLevel()  (optional quality)
 */

/**
 * @typedef {object} StreamingSource
 * @property {string} src
 * @property {string} [type]
 * @property {string} [poster]
 */

/**
 * @typedef {object} StreamingProvider
 * @property {function(): Promise<void>} initialize
 * @property {function(StreamingSource): boolean} supports
 * @property {function(HTMLVideoElement): void} attach
 * @property {function(): void} detach
 * @property {function(StreamingSource, object=): Promise<void>} load
 * @property {function(): void} destroy
 * @property {function(): string} getName
 * @property {function(): object[]} [getLevels]
 * @property {function(number): void} [setLevel]
 * @property {function(): number} [getCurrentLevel]
 * @property {function(string, function): function} [on]
 * @property {function(string, function): void} [off]
 */

export var StreamingProviderEvents = Object.freeze({
  MANIFEST_PARSED: "manifestParsed",
  LEVEL_SWITCHED: "levelSwitched",
  ERROR: "error",
  RETRY: "retry",
  DESTROYED: "destroyed",
});

export default StreamingProviderEvents;
